import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import { DMSDeal } from '@upstart/harmony/lib/legos/dmsTypes';

export const buildFinanceResponseWithDMSDeal = (
  financeResponse: FinanceResponse,
  dmsDeal: DMSDeal,
): FinanceResponse => ({
  ...financeResponse,
  data: {
    ...financeResponse.data,
    ...dmsDeal.data,
    carStock: financeResponse?.data?.carStock,
    carCondition: financeResponse?.data?.carCondition,
  },
});
